import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa"
import { SOCIAL_LINKS } from "../../constants"

const iconMap = {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
}

export default function ContactBar() {
  return (
    <div className="flex items-center justify-center gap-4">
      {SOCIAL_LINKS.map((item) => {
        const Icon = iconMap[item.icon]
        const isMailto = item.url.startsWith("mailto:")
        const externalProps = isMailto
          ? {}
          : { target: "_blank", rel: "noopener noreferrer" }

        return (
          <a
            key={item.url}
            href={item.url}
            {...externalProps}
            className="group relative flex items-center text-foreground transition-transform duration-200 hover:scale-110 motion-reduce:transition-none motion-reduce:hover:transform-none"
          >
            <div className="relative text-2xl">
              <Icon />
              <span className="pointer-events-none absolute left-1/2 top-full z-20 mt-2 -translate-x-1/2 whitespace-nowrap rounded border border-border bg-surface px-2 py-1 text-xs text-foreground opacity-0 shadow-[0_2px_8px_rgba(0,0,0,0.25)] transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100">
                {item.name}
              </span>
            </div>
          </a>
        )
      })}
    </div>
  )
}
